import { Eye, EyeOff } from 'lucide-react';
import { useState } from 'react';
import { IconButton } from './IconButton';
import { Input, type InputProps } from './Input';

export type PasswordInputProps = Omit<InputProps, 'type' | 'trailingSlot'>;

/**
 * Pole hasla z przelacznikiem widocznosci.
 *
 * Stan „pokaz haslo” celowo nie jest podnoszony wyzej — to decyzja lokalna
 * dla kontrolki i nie powinna trafiac do stanu formularza.
 */
export function PasswordInput(props: PasswordInputProps) {
  const [visible, setVisible] = useState(false);

  return (
    <Input
      type={visible ? 'text' : 'password'}
      autoComplete="current-password"
      trailingSlot={
        <IconButton
          variant="ghost"
          size="sm"
          icon={visible ? <EyeOff /> : <Eye />}
          label={visible ? 'Ukryj hasło' : 'Pokaż hasło'}
          onClick={() => setVisible((current) => !current)}
          // Przelacznik nie powinien lapac fokusu przy przechodzeniu tabem
          // przez formularz — dostepny jest przez czytnik ekranu i mysz.
          tabIndex={-1}
        />
      }
      {...props}
    />
  );
}
